<template>
  <div class="modal-window">
    <button type="button" @click="$emit('close')" class="button button--close">
      <font-awesome-icon icon="times" />
    </button>
    <h2>Plan Changed!</h2>
    <p>Your plan has sucessfully been changed.</p>
    <button
      type="button"
      class="button layout--margin-bottom-sm layout--block layout--center"
      @click="$emit('close')"
    >
      Ok!
    </button>
  </div>
</template>

<script>
export default {
  name: "successModal",
};
</script>

<style></style>
